import React from 'react';

const FullScreenLoadingState = ({ message = '불러오는 중...' }) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground caption">{message}</p>
      </div>
    </div>
  );
};

export default FullScreenLoadingState;
